import type { KeyboardEvent } from "react";

/**
 * The employee PIN box. Submits on Enter, matching `codeTextBox_KeyUp`
 * (AddItemWindow.xaml.cs:819) exactly — an explicit key handler, not
 * incidental HTML form-submission, since jsdom does not implement implicit
 * form submission on Enter and the legacy behaviour was itself an explicit
 * `KeyUp` check, not a form.
 */
export function PinField({
  id,
  label,
  value,
  onChange,
  onSubmit,
  disabled = false,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled?: boolean;
}) {
  function handleKeyDown(event: KeyboardEvent<HTMLInputElement>) {
    if (event.key === "Enter") {
      event.preventDefault();
      onSubmit();
    }
  }

  return (
    <div className="form-field pin-field">
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type="password"
        inputMode="numeric"
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
      />
    </div>
  );
}
